var styles = {
  "Item": "Online-Store-UI-Item_1mxyu",
  "disabled": "Online-Store-UI-Item--disabled_19wwb",
  "active": "Online-Store-UI-Item--active_1i0bm",
  "current": "Online-Store-UI-Item--current_srvj2",
  "interactive": "Online-Store-UI-Item--interactive_h492e",
  "Action": "Online-Store-UI-Item__Action_1ddpm",
  "disabledBackground": "Online-Store-UI-Item--disabledBackground_1htd2",
  "Content": "Online-Store-UI-Item__Content_srnxb",
  "IconPrefix": "Online-Store-UI-Item__IconPrefix_18c24",
  "Prefix": "Online-Store-UI-Item__Prefix_1jwfk",
  "Suffix": "Online-Store-UI-Item__Suffix_1jwfj"
};

export { styles as default };
